import {useEffect, useState} from 'react';

import moment from 'moment';

import {Button} from 'primereact/button';

import {InvoiceService} from '../../hoa-don/InvoiceService';
import {RegisterInvoiceService} from '../../../service/invoice/RegisterInvoiceService';
import {IntegratedReportService as Service} from './IntegratedReportService';

import {useForm} from '../../../shared/hooks/Form';

const periods = [
  {value: 'TODAY', label: 'Hôm nay'},
  {value: 'THISWEEK', label: 'Tuần này'},
  {value: 'THISMONTH', label: 'Tháng này'},
  {value: 'THISFISCALQUARTER', label: 'Quý này'},
  {value: 'THISFISCALYEAR', label: 'Năm nay'},
  {value: 'FIRSTSIXMONTH', label: '6 tháng đầu năm'},
  {value: 'LASTSIXMONTH', label: '6 tháng cuối năm'},
  {value: 'JAN', label: 'Tháng 1'},
  {value: 'FEB', label: 'Tháng 2'},
  {value: 'MAR', label: 'Tháng 3'},
  {value: 'APR', label: 'Tháng 4'},
  {value: 'MAY', label: 'Tháng 5'},
  {value: 'JUN', label: 'Tháng 6'},
  {value: 'JUL', label: 'Tháng 7'},
  {value: 'AUG', label: 'Tháng 8'},
  {value: 'SEP', label: 'Tháng 9'},
  {value: 'OCT', label: 'Tháng 10'},
  {value: 'NOV', label: 'Tháng 11'},
  {value: 'DEC', label: 'Tháng 12'},
  {value: 'FISCALQUARTER1', label: 'Quý I'},
  {value: 'FISCALQUARTER2', label: 'Quý II'},
  {value: 'FISCALQUARTER3', label: 'Quý III'},
  {value: 'FISCALQUARTER4', label: 'Quý IV'},
  {value: 'LASTWEEK', label: 'Tuần trước'},
  {value: 'LASTMONTH', label: 'Tháng trước'},
  {value: 'LASTFISCALQUARTER', label: 'Quý trước'},
  {value: 'LASTFISCALYEAR', label: 'Năm trước'}
];

export default function NhanPmkt() {

  const [registerInvoices, setRegisterInvoices] = useState([]);
  const [vendors, setVendors] = useState([]);

  useEffect(() => {
    RegisterInvoiceService.getUsingList({maxResultCount: 1000}).then(({items}) => {
      const _registerInvoices = [];
      items.forEach(item => {
        _registerInvoices.push({value: item.symbolCode, label: item.symbolCode});
      });
      setRegisterInvoices(_registerInvoices);
    });

    Service.getVendors().then(({items}) => {
      const _vendors = [];
      items.forEach(item => {
        _vendors.push({value: item.code, label: item.name});
      });
      setVendors(_vendors);
    });
  }, []);

  useEffect(() => {
    if (vendors && vendors.length) {
      const _value = getValue();
      _value.period = 'THISMONTH';
      _value.invoiceStatus = [0,2,3,4,5];
      _value.sendTaxStatus = [4];
      _value.vendorCode = vendors[0].value;
      setValue(_value);
    }
  }, [vendors]); // eslint-disable-line react-hooks/exhaustive-deps

  const {render: renderForm, getValue, setValue} = useForm({
    fields: [
      {field: 'period', header: 'Chọn kỳ', type: 'Dropdown', DropdownProps: {options: periods}, className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'fromDate', header: 'Từ ngày', type: 'Calendar', className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'toDate', header: 'Đến ngày', type: 'Calendar', className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'symbol', header: 'Ký hiệu', type: 'MultiSelect', MultiSelectProps: {options: registerInvoices,filter: true}, className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {
        field: 'invoiceStatus',
        header: 'Trạng thái hóa đơn',
        type: 'MultiSelect',
        MultiSelectProps: {options: InvoiceService.invoiceStatuses,filter: true},
        className: 'md:col-4',
        labelClassName: 'md:col-4',
        inputClassName: 'md:col-8'
      },
      {
        field: 'sendTaxStatus',
        header: 'Trạng thái gửi CQT',
        type: 'MultiSelect',
        MultiSelectProps: {options: InvoiceService.sendTaxStatuses, filter: true},
        className: 'md:col-4',
        labelClassName: 'md:col-4',
        inputClassName: 'md:col-8'
      },
      {field: 'vendorCode', header: 'Phần mềm kế toán', type: 'Dropdown', DropdownProps: {options: vendors}, className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8'}
    ],
    layout: 'Horizontal',
  });

  const {period} = getValue();
  useEffect(() => {
    if (period) {
      let fromDate = new Date(), toDate = new Date();

      const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
      const quarters = ['FISCALQUARTER1', 'FISCALQUARTER2', 'FISCALQUARTER3', 'FISCALQUARTER4'];
      if (period && months.indexOf(period) >= 0) {
        fromDate = moment().month(months.indexOf(period)).startOf('month').toDate();
        toDate = moment().month(months.indexOf(period)).endOf('month').toDate();
      } else if (period && quarters.indexOf(period) >= 0) {
        fromDate = moment().quarter(quarters.indexOf(period) + 1).startOf('quarter').toDate();
        toDate = moment().quarter(quarters.indexOf(period) + 1).endOf('quarter').toDate();
      } else {
        switch (period) {
          case 'TODAY':
            fromDate = moment().startOf('day').toDate();
            toDate = moment().endOf('day').toDate();
            break;
          case 'THISWEEK':
            fromDate = moment().startOf('isoWeek').toDate();
            toDate = moment().endOf('isoWeek').toDate();
            break;
          case 'THISWEEKTODATE':
            fromDate = moment().startOf('isoWeek').toDate();
            break;
          case 'THISMONTH':
            fromDate = moment().startOf('month').toDate();
            toDate = moment().endOf('month').toDate();
            break;
          case 'THISMONTHTODATE':
            fromDate = moment().startOf('month').toDate();
            break;
          case 'THISFISCALQUARTER':
            fromDate = moment().startOf('quarter').toDate();
            toDate = moment().endOf('quarter').toDate();
            break;
          case 'THISFISCALQUARTERTODATE':
            fromDate = moment().startOf('quarter').toDate();
            break;
          case 'THISFISCALYEAR':
            fromDate = moment().startOf('year').toDate();
            toDate = moment().endOf('year').toDate();
            break;
          case 'THISFISCALYEARTODATE':
            fromDate = moment().startOf('year').toDate();
            break;
          case 'FIRSTSIXMONTH':
            fromDate = moment().startOf('year').toDate();
            toDate = moment().month(5).endOf('month').toDate();
            break;
          case 'LASTSIXMONTH':
            fromDate = moment().month(6).startOf('month').toDate();
            toDate = moment().endOf('year').toDate();
            break;
          case 'YESTERDAY':
            fromDate = moment().subtract(1, 'day').startOf('day').toDate();
            toDate = moment().subtract(1, 'day').endOf('day').toDate();
            break;
          case 'LASTWEEK':
            fromDate = moment().subtract(1, 'week').startOf('isoWeek').toDate();
            toDate = moment().subtract(1, 'week').endOf('isoWeek').toDate();
            break;
          case 'LASTMONTH':
            fromDate = moment().subtract(1, 'month').startOf('month').toDate();
            toDate = moment().subtract(1, 'month').endOf('month').toDate();
            break;
          case 'LASTFISCALQUARTER':
            fromDate = moment().subtract(1, 'quarter').startOf('quarter').toDate();
            toDate = moment().subtract(1, 'quarter').endOf('quarter').toDate();
            break;
          case 'LASTFISCALYEAR':
            fromDate = moment().subtract(1, 'year').startOf('year').toDate();
            toDate = moment().subtract(1, 'year').endOf('year').toDate();
            break;
          case 'NEXTWEEK':
            fromDate = moment().add(1, 'week').startOf('isoWeek').toDate();
            toDate = moment().add(1, 'week').endOf('isoWeek').toDate();
            break;
          case 'NEXTMONTH':
            fromDate = moment().add(1, 'month').startOf('month').toDate();
            toDate = moment().add(1, 'month').endOf('month').toDate();
            break;
          case 'NEXTFISCALQUARTER':
            fromDate = moment().add(1, 'quarter').startOf('quarter').toDate();
            toDate = moment().add(1, 'quarter').endOf('quarter').toDate();
            break;
          case 'NEXTFISCALYEAR':
            fromDate = moment().add(1, 'year').startOf('year').toDate();
            toDate = moment().add(1, 'year').endOf('year').toDate();
            break;
        }
      }
      const _value = getValue();
      _value.fromDate = fromDate;
      _value.toDate = toDate;
      setValue(_value);
    }
  }, [period]); // eslint-disable-line react-hooks/exhaustive-deps

  const apply = () => {
    const _value = getValue();
    if (_value.symbol) {
      _value.symbol = _value.symbol.join(',');
    }

    if (_value.invoiceStatus) {
      _value.invoiceStatus = _value.invoiceStatus.join(',');
    }

    if (_value.sendTaxStatus) {
      _value.sendTaxStatus = _value.sendTaxStatus.join(',');
    }
    
    Service.downloadExcel(_value).then(data => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `nhan-pmkt.xlsx`;
      link.click();
    });
  }

  return (
    <div className="card">
      {renderForm()}

      <div className="flex">
        <Button label="Kết xuất" icon="pi pi-file-excel" onClick={apply}/>
      </div>
    </div>
  );
}